/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import template from './report-schedule-list-page.component.html';

import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../common/controller/signal-admin-resource-list-state';
import {ReportScheduleApiService, ReportScheduleModel} from './report-schedule-api.service';
import {UIRouterModule} from '@uirouter/angular';
import {APP_SHARED} from '../common/app-shared';
import {SignalAdminResourceListComponent} from '../common/controller/signal-admin-resource-list.component';
import {NextReportComponent} from './next-report.component';
import {ReportUrlComponent} from './report-url-component';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule, SignalAdminResourceListComponent, NextReportComponent, ReportUrlComponent],
  selector: 'adn-report-schedule-list-page',
  template
})
export class ReportScheduleListPageComponent implements OnInit {
  readonly itemStateName = 'app.rep.report-schedules.report-schedule';
  readonly reportTemplateStateName = 'app.rep.report-templates.report-template';

  columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {label: 'reportTemplate', param: '', sortable: false},
    {label: 'staticUrl', param: '', sortable: false},
    {param: 'recurrence'},
    {param: 'period', label: 'reportDates'},
    {param: 'scheduledFor', label: 'nextExecution'}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<ReportScheduleModel>(
    inject(ReportScheduleApiService),
    {listId: 'fullReportScheduleList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
